export default __webpack_public_path__ + "static/media/pic.5f940e34.svg";